import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { ConfigurationKey, ITogglesService } from '@/app-modules/config';
import { WebSocketUserSettingsUpdatedEventName } from '@/components/user-settings/_domain/models/events';
import { ISweetAlertService } from '@/app-modules/sweet-alert-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
@Component({
  name: 'DeveloperComponent'
})
export default class DeveloperComponent extends TombolaBaseComponent {
  @Prop() public userPreferences: UserPreferences;
  private logWebSocketActivity: boolean = false;
  private overrideConnectionTimeouts: boolean = false;
  private useAutomaticBackoffValue: boolean = false;
  private webSocketConnectionTimeoutInSeconds: number = 0;

  private get useAutomaticBackoff(): boolean {
    return this.useAutomaticBackoffValue && this.overrideConnectionTimeouts;
  }

  private set useAutomaticBackoff(value: boolean) {
    this.useAutomaticBackoffValue = value;
  }

  private get minWebSocketConnectionTimeoutInSeconds(): number {
    return Number(this.configService.getConfigurationItem(ConfigurationKey.CHAT_WEBSOCKET_KEEP_ALIVE_TIMEOUT_MILLISECONDS)) / 1000;
  }

  private get sweetAlertService(): ISweetAlertService {
    return this.$container.get(SERVICE_IDENTIFIERS.ISweetAlertService);
  }

  private get toggleService(): ITogglesService {
    return this.$container.get(SERVICE_IDENTIFIERS.ITogglesService);
  }

  protected created() {
    this.logWebSocketActivity = this.userPreferences.logWebSocketActivity;
    this.overrideConnectionTimeouts = this.userPreferences.connectionTimeoutOverrides.overrideEnabled;
    this.useAutomaticBackoff = this.userPreferences.connectionTimeoutOverrides.useAutomaticBackoff;
    this.webSocketConnectionTimeoutInSeconds = this.userPreferences.connectionTimeoutOverrides.webSocketConnectionTimeoutInSeconds;
  }

  public saveSettings() {
    this.userPreferences.logWebSocketActivity = this.logWebSocketActivity;

    const hasConnectionTimeoutOverridesChanged = this.hasConnectionTimeoutOverridesChanged();
    this.userPreferences.connectionTimeoutOverrides.overrideEnabled = this.overrideConnectionTimeouts;
    this.userPreferences.connectionTimeoutOverrides.useAutomaticBackoff = this.useAutomaticBackoff;
    this.userPreferences.connectionTimeoutOverrides.webSocketConnectionTimeoutInSeconds = this.webSocketConnectionTimeoutInSeconds;
    if (hasConnectionTimeoutOverridesChanged) {
      this.$eventbus.$emit(WebSocketUserSettingsUpdatedEventName);
    }
  }

  private hasConnectionTimeoutOverridesChanged(): boolean {
    const overrides = this.userPreferences.connectionTimeoutOverrides;
    return (this.overrideConnectionTimeouts !== overrides.overrideEnabled) ||
      (this.useAutomaticBackoff !== overrides.useAutomaticBackoff) ||
      (this.webSocketConnectionTimeoutInSeconds !== overrides.webSocketConnectionTimeoutInSeconds);
  }

  private resetAll() {
    this.logWebSocketActivity = false;
    this.overrideConnectionTimeouts = false;
    this.useAutomaticBackoff = false;
    this.webSocketConnectionTimeoutInSeconds = this.getDefaultChatConnectionTimeout();
  }

  private async refreshToggleCache() {

    const result = await this.sweetAlertService.show({
      title: this.$lang.app.userSettings.developer.clearToggleCacheTitle,
      text: this.$lang.app.userSettings.developer.clearToggleCacheMessage,
      type: 'warning',
      allowOutsideClick: false,
      focusConfirm: false,
      showConfirmButton: true,
      showCancelButton: true
    });

    if (result && result.value) {
      const useNewToggleEndPoint = await this.toggleService.isLive('CIC-494_UseNETToggleSystem');
      await this.toggleService.refreshToggleCache(useNewToggleEndPoint);
    }

  }

  private getDefaultChatConnectionTimeout(): number {
    return Number(this.configService.getConfigurationItem(ConfigurationKey.CHAT_WEBSOCKET_CONNECTION_LOST_DETECTION_TIMEOUT_MILLISECONDS)) / 1000;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/developer/developer.component.ts